import { render } from "./ReportsView.vue?vue&type=template&id=54c8d3c4&scoped=true"
import script from "./ReportsView.vue?vue&type=script&lang=js"
export * from "./ReportsView.vue?vue&type=script&lang=js"

import "./ReportsView.vue?vue&type=style&index=0&id=54c8d3c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c8d3c4"]])

export default __exports__